module.exports = __webpack_public_path__ + "static/img/deposit_steps.df737c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/deposit_steps.jpg
// module id = k/jQ
// module chunks = 0